import { type RoleUsuario } from '@varga/shared';

/**
 * Sessão do operador (UX-PAINEL-INTERNO §0.7):
 * - access token: só em memória (nunca em storage).
 * - refresh token: `localStorage` — para o refresh silencioso sobreviver a um
 *   reload de página. Não é estado de negócio.
 * - rascunho de tela + rota pretendida: `sessionStorage` — "conveniência de
 *   apresentação, nunca estado de negócio" (CLAUDE.md). Usado para não perder uma
 *   OS meio-digitada quando a sessão expira.
 */

export interface UsuarioSessao {
  id: string;
  role: RoleUsuario;
  clienteId: string | null;
  nome: string | null;
}

const CHAVE_REFRESH = 'varga.painel.refresh';
const CHAVE_DESTINO = 'varga.painel.destino';
const PREFIXO_RASCUNHO = 'varga.painel.rascunho.';

let accessToken: string | null = null;
let usuario: UsuarioSessao | null = null;

export const getAccessToken = (): string | null => accessToken;
export const getUsuario = (): UsuarioSessao | null => usuario;

export function setSessao(access: string, refresh: string, u: UsuarioSessao): void {
  accessToken = access;
  usuario = u;
  try {
    localStorage.setItem(CHAVE_REFRESH, refresh);
  } catch {
    /* storage indisponível — segue só em memória */
  }
}

export function atualizarAccess(access: string, refresh: string, u: UsuarioSessao): void {
  accessToken = access;
  usuario = u;
  try {
    localStorage.setItem(CHAVE_REFRESH, refresh);
  } catch {
    /* ignore */
  }
}

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(CHAVE_REFRESH);
  } catch {
    return null;
  }
}

export function limparSessao(): void {
  accessToken = null;
  usuario = null;
  try {
    localStorage.removeItem(CHAVE_REFRESH);
  } catch {
    /* ignore */
  }
}

// ── rota pretendida (para voltar depois do login) ──────────────────────────────
export function guardarDestino(rota: string): void {
  try {
    sessionStorage.setItem(CHAVE_DESTINO, rota);
  } catch {
    /* ignore */
  }
}
export function lerDestino(): string | null {
  try {
    return sessionStorage.getItem(CHAVE_DESTINO);
  } catch {
    return null;
  }
}
export function limparDestino(): void {
  try {
    sessionStorage.removeItem(CHAVE_DESTINO);
  } catch {
    /* ignore */
  }
}

// ── rascunho de tela (ex.: formulário de cadastro meio-preenchido) ─────────────
export function salvarRascunho(chave: string, valor: unknown): void {
  try {
    sessionStorage.setItem(PREFIXO_RASCUNHO + chave, JSON.stringify(valor));
  } catch {
    /* ignore */
  }
}
export function lerRascunho<T>(chave: string): T | null {
  try {
    const cru = sessionStorage.getItem(PREFIXO_RASCUNHO + chave);
    return cru ? (JSON.parse(cru) as T) : null;
  } catch {
    return null;
  }
}
export function limparRascunho(chave: string): void {
  try {
    sessionStorage.removeItem(PREFIXO_RASCUNHO + chave);
  } catch {
    /* ignore */
  }
}
